import React from "react";

import banner from "../../assets/images/real.jpg";

const serviceAreas = [
  {
    title: "سداد قروض صبيا",
    text: "مكتب صبيا ومكتب سداد صبيا لتسديد القروض، سداد سمة، وفك إيقاف الخدمات لسكان محافظة صبيا.",
  },
  {
    title: "مكتب سداد أبو عريش",
    text: "تسديد قروض أبو عريش وسداد إيقاف الخدمات لدى الراجحي والأهلي وبقية البنوك بسرية تامة.",
  },
  {
    title: "سداد قروض جازان",
    text: "مكتب سداد جازان لسداد الديون، تحويل الراتب، وجدولة المديونية واستخراج تمويل جديد.",
  },
  {
    title: "سداد قروض بيش",
    text: "خدمة سداد متعثرات سمة وفك إيقاف الخدمات لعملاء بيش حضوريًا أو عن بُعد.",
  },
  {
    title: "سداد قروض صامطة",
    text: "تسديد قروض صامطة ورفع الاسم من سمة ومتابعة المخالصة البنكية بسرعة.",
  },
  {
    title: "سداد قروض أحد المسارحة",
    text: "حلول سداد ديون البنوك وإنهاء التعثر البنكي لسكان أحد المسارحة.",
  },
  {
    title: "سداد قروض ضمد وفيفا",
    text: "مكتب خدمات مالية لسداد القروض الشخصية والعقارية في ضمد وفيفا.",
  },
  {
    title: "سداد قروض فرسان والطوال",
    text: "متابعة حالات إيقاف الخدمات والتعثر البنكي في فرسان والطوال.",
  },
  {
    title: "الدائر · العارضة · العيدابي",
    text: "سداد مديونيات وجدولة القروض وتوحيد الالتزامات لسكان الدائر والعارضة والعيدابي.",
  },
  {
    title: "الريث · الحرث · هروب",
    text: "خدمة عن بُعد لتسديد الديون وسداد سمة وفك الحظر البنكي.",
  },
  {
    title: "سداد قروض الراجحي والأهلي",
    text: "تسديد قروض الراجحي والأهلي والرياض والإنماء والبلاد والجزيرة والعربي.",
  },
  {
    title: "بنك التنمية والتسليف",
    text: "استخراج تمويل من بنك التنمية الاجتماعية وقرض التسليف بعد تسوية الالتزامات.",
  },
];

const popularServices = [
  "تسديد متعثرات سمة",
  "رفع الاسم من سمة",
  "تحديث سمة",
  "فك الحظر من سمة",
  "مخالصة بنكية",
  "فك إيقاف الخدمات",
  "رفع إيقاف الخدمات",
  "إيقاف خدمات ناجز",
  "سداد ديون البنوك",
  "تسديد ديون",
  "سداد مبكر للقروض",
  "جدولة القروض",
  "جدولة المديونية",
  "توحيد الالتزامات",
  "تحويل الراتب",
  "استخراج قرض جديد",
  "قرض شخصي",
  "تمويل شخصي",
  "قرض عقاري",
  "تمويل عقاري",
  "سداد قرض شخصي",
  "سداد قرض عقاري",
  "سداد بطاقة ائتمانية",
  "سداد قروض المدنيين",
  "سداد قروض العسكريين",
  "سداد قروض القطاع الخاص",
  "تمويل عقاري بدون فوائد",
  "قرض حتى 36 راتب",
];

const features = [
  {
    icon: "fa-balance-scale",
    title: "معاملات شرعية",
    text: "جميع حلولنا المالية متوافقة تماماً مع أحكام الشريعة الإسلامية والأنظمة البنكية في المملكة العربية السعودية.",
  },
  {
    icon: "fa-bolt",
    title: "سرعة في التنفيذ",
    text: "ننجز معاملات سداد القروض والتعثرات وتحويل الرواتب والمخالصة البنكية في أقل وقت ممكن.",
  },
  {
    icon: "fa-user-shield",
    title: "سرية وأمان تام",
    text: "نتعامل مع بيانات عملائنا وسجلاتهم البنكية بأعلى درجات السرية والخصوصية والأمان.",
  },
];

const realEstateBenefits = [
  {
    icon: "fa-home",
    tone: "warning",
    title: "تملك منزل",
    text: "امتلك عقارك السكني مع تمويل عقاري مناسب ووحدة سكنية جاهزة عند توفر الشروط.",
  },
  {
    icon: "fa-hand-holding-usd",
    tone: "primary",
    title: "التخلص من الأعباء المالية",
    text: "سداد كامل للديون والالتزامات البنكية لتبدأ حياة جديدة باستقرار مالي بعد رفع الاسم من سمة.",
  },
  {
    icon: "fa-chart-line",
    tone: "success",
    title: "سيولة وتمويل جديد",
    text: "بعد تسوية المتعثرات يمكنك استخراج قرض شخصي أو تمويل جديد حتى 36 راتب حسب الأهلية البنكية.",
  },
];

const workSteps = [
  {
    title: "تواصل معنا",
    text: "اشرح حالتك: سداد قروض، تعثر سمة، إيقاف خدمات، أو تحويل راتب.",
  },
  {
    title: "دراسة الطلب",
    text: "نراجع الالتزامات ونختار أفضل حل: جدولة، توحيد ديون، أو سداد كامل.",
  },
  {
    title: "التنفيذ الفوري",
    text: "سداد المديونية، تحديث سمة، فك إيقاف الخدمات، أو استخراج قرض جديد.",
  },
];

const faqItems = [
  {
    id: "faq1",
    question: "هل أنتم بنك أو جهة تمويلية؟",
    answer:
      "لا، نحن مكتب خدمات وسيط نقوم بمساعدة العميل بسداد متعثراته وتوفير السيولة اللازمة لإنهاء الالتزامات البنكية وإعادة جدولة التمويل عبر البنوك الرسمية المعتمدة في المملكة.",
    open: true,
  },
  {
    id: "faq2",
    question: 'كم تستغرق عملية تحديث الاسم في "سمة" بعد السداد؟',
    answer:
      "نقوم برفع طلب المخالصة وسداد المديونية فوراً، وعادةً ما يستغرق تحديث البيانات في نظام سمة بشكل رسمي من 24 إلى 48 ساعة عمل.",
  },
  {
    id: "faq3",
    question: "هل تقدمون سداد قروض صبيا ومكتب سداد أبو عريش؟",
    answer:
      "نعم، نخدم عملاء صبيا وأبو عريش وجازان وبيش وصامطة وأحد المسارحة وضمد وفيفا وفرسان والدائر والعارضة والطوال والعيدابي والريث والحرث وهروب، سواء بالحضور أو عن بُعد.",
  },
  {
    id: "faq4",
    question: "ما الخدمات الأكثر طلبًا في السعودية؟",
    answer:
      "أكثر ما يبحث عنه العملاء: تسديد متعثرات سمة، فك إيقاف الخدمات، سداد قروض الراجحي والأهلي، تحويل الراتب، سداد مبكر للقروض، جدولة المديونية، واستخراج قرض أو تمويل جديد.",
  },
  {
    id: "faq5",
    question: "هل يمكن سداد قروض جميع البنوك؟",
    answer:
      "نعم، نساعد في سداد قروض الراجحي والأهلي وبنك الرياض ومصرف الإنماء وبنك البلاد وبنك الجزيرة والبنك العربي وساب وبنك التنمية الاجتماعية (التسليف).",
  },
  {
    id: "faq6",
    question: "هل الخدمة سرية؟",
    answer:
      "نعم، جميع معاملات سداد القروض والتعثرات البنكية تتم بسرية تامة مع حماية بيانات العميل وسجلاته المالية.",
  },
];

function Home() {
  return (
    <main id="main-content" dir="rtl">
      <section className="hero" id="home" aria-labelledby="hero-heading">
        <div className="container py-4 py-lg-5">
          <div className="row align-items-center justify-content-between g-4 g-lg-5">
            <div className="col-12 col-lg-6 text-center text-lg-end">
              <p className="hero-badge">صبيا · أبو عريش · جازان · بيش · صامطة</p>
              <h1 id="hero-heading" className="hero-title display-5 my-3">
                سداد قروض <span className="text-primary">صبيا</span> | أبو عريش
                وجازان
              </h1>
              <p className="hero-lead mb-3 mx-auto mx-lg-0">
                مكتب صبيا ومكتب سداد أبو عريش لخدمة تسديد القروض، سداد متعثرات
                سمة، فك إيقاف الخدمات، تحويل الراتب، واستخراج قرض جديد بطرق
                شرعية ونظامية 100%.
              </p>
              <p className="text-secondary small mb-4">
                نغطي أيضًا: بيش، أحد المسارحة، صامطة، ضمد، فيفا، فرسان، الدائر،
                العارضة، الطوال، العيدابي، الريث، الحرث، وهروب.
              </p>

              <ul className="d-flex flex-column flex-sm-row gap-3 pt-1 justify-content-center justify-content-lg-start list-unstyled mb-0">
                <li>
                  <a
                    className="btn btn-cta-whatsapp btn-lg px-4 py-3 d-inline-flex align-items-center justify-content-center gap-2 fw-bold"
                    href="https://wa.me/+9660530179640"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-whatsapp fs-4" aria-hidden="true"></i>
                    تواصل عبر الواتساب فوراً
                  </a>
                </li>
                <li>
                  <a
                    className="btn btn-cta-call btn-lg px-4 py-3 d-inline-flex align-items-center justify-content-center gap-2 fw-bold"
                    href="tel:0530179640"
                  >
                    <i className="fas fa-phone-alt" aria-hidden="true"></i>
                    اتصال هاتفي مباشر
                  </a>
                </li>
              </ul>
            </div>

            <figure className="hero-cover col-12 col-lg-5 m-0">
              <img
                src={banner}
                alt="سداد قروض صبيا ومكتب سداد أبو عريش وجازان وتسديد متعثرات سمة"
                width="600"
                height="350"
              />
              <figcaption className="visually-hidden">
                خدمة سداد القروض والتعثرات البنكية في صبيا وأبو عريش وجازان
              </figcaption>
            </figure>
          </div>
        </div>
      </section>

      <section
        className="section section-alt"
        id="features"
        aria-labelledby="features-heading"
      >
        <div className="container">
          <header className="section-head text-center">
            <h2 id="features-heading">
              لماذا يعتمد علينا عملاء صبيا وأبو عريش وجازان؟
            </h2>
            <p className="text-muted mb-0">
              أفضل مكتب تسديد قروض ووسيط سداد متعثرات لإنهاء الأعباء البنكية
              بسرعة وأمان
            </p>
          </header>

          <ul className="row g-4 list-unstyled mb-0">
            {features.map((feature) => (
              <li key={feature.title} className="col-12 col-md-4">
                <article className="feature-card">
                  <div className="feature-icon mx-auto" aria-hidden="true">
                    <i className={`fas ${feature.icon}`}></i>
                  </div>
                  <h3 className="fw-bold mb-2 h4">{feature.title}</h3>
                  <p className="text-muted small mb-0">{feature.text}</p>
                </article>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section
        className="section"
        id="keywords-services"
        aria-labelledby="popular-services-heading"
      >
        <div className="container">
          <header className="section-head text-center">
            <h2 id="popular-services-heading">
              خدمات سداد القروض الأكثر بحثًا في السعودية
            </h2>
            <p className="text-muted col-lg-9 mx-auto mb-0">
              نقدّم حلول سداد قروض صبيا، مكتب سداد أبو عريش، وتسديد متعثرات سمة
              وفك إيقاف الخدمات لكل من يبحث عن إنهاء التعثر البنكي في منطقة
              جازان.
            </p>
          </header>

          <ul className="row g-2 list-unstyled mb-0">
            {popularServices.map((service) => (
              <li key={service} className="col-6 col-md-4 col-lg-3">
                <p className="service-chip">{service}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section
        className="section section-alt"
        id="real-estate"
        aria-labelledby="real-estate-heading"
      >
        <div className="container">
          <header className="section-head text-center">
            <p className="section-kicker">حلول سكنية وتمويل عقاري</p>
            <h2 id="real-estate-heading" className="display-6">
              تمويل عقاري وتملك منزل مع{" "}
              <span className="text-primary">سداد المديونيات</span>
            </h2>
            <p className="text-muted fs-5 mb-0">
              من خلال خدمات التمويل العقاري وسداد القروض في صبيا وأبو عريش
              وجازان يمكنك تحقيق الآتي:
            </p>
          </header>

          <ul className="row g-4 justify-content-center list-unstyled mb-0">
            {realEstateBenefits.map((item) => (
              <li key={item.title} className="col-12 col-md-4">
                <article className={`benefit-card is-${item.tone}`}>
                  <div className="benefit-icon mx-auto" aria-hidden="true">
                    <i className={`fas ${item.icon}`}></i>
                  </div>
                  <h3 className="fw-bold mb-3 h4">{item.title}</h3>
                  <p className="text-muted mb-0 fw-medium">{item.text}</p>
                </article>
              </li>
            ))}
          </ul>

          <footer className="text-center mt-5">
            <p className="fw-bold text-secondary mb-3">
              كل ما تحتاجه لبدء حياة جديدة متوفر لدينا الآن في صبيا وأبو عريش
              وجازان
            </p>
            <a
              href="https://wa.me/+9660530179640"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline-brand btn-lg px-5 py-3"
            >
              <i className="fab fa-whatsapp ms-2" aria-hidden="true"></i>
              استشر مستشارنا مجاناً
            </a>
          </footer>
        </div>
      </section>

      <section
        className="section"
        id="steps"
        aria-labelledby="steps-heading"
      >
        <div className="container">
          <header className="section-head text-center">
            <h2 id="steps-heading">خطوات سهلة لسداد القروض وإنهاء التعثر</h2>
            <p className="text-muted mb-0">
              من التواصل حتى المخالصة البنكية ورفع الاسم من سمة
            </p>
          </header>

          <ol className="row g-4 justify-content-center list-unstyled mb-0">
            {workSteps.map((step, index) => (
              <li key={step.title} className="col-12 col-md-4">
                <div className="step-item">
                  <div className="step-num" aria-hidden="true">
                    {index + 1}
                  </div>
                  <h3 className="fw-bold h5">{step.title}</h3>
                  <p className="text-muted small px-2 mb-0">{step.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section
        className="section section-alt"
        id="areas"
        aria-labelledby="areas-heading"
      >
        <div className="container">
          <header className="section-head text-center">
            <h2 id="areas-heading">
              مناطق خدمتنا في جازان — سداد قروض لكل المحافظات
            </h2>
            <p className="text-muted col-lg-9 mx-auto mb-0">
              سواء كنت تبحث عن سداد قروض صبيا أو مكتب سداد أبو عريش أو تسديد
              قروض جازان وبيش وصامطة؛ نحن نغطي أغلب محافظات المنطقة.
            </p>
          </header>

          <ul className="row g-3 justify-content-center list-unstyled mb-0">
            {serviceAreas.map((area) => (
              <li key={area.title} className="col-12 col-md-6 col-lg-4">
                <article className="area-card">
                  <h3 className="fw-bold h5 mb-2">{area.title}</h3>
                  <p className="text-muted small mb-0">{area.text}</p>
                </article>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="section" id="about" aria-labelledby="about-heading">
        <div className="container">
          <article className="row justify-content-center">
            <div className="col-12 col-lg-10">
              <div className="about-panel">
                <h2 id="about-heading" className="fw-bold mb-3 text-center">
                  مكتب سداد قروض صبيا وأبو عريش وجازان
                </h2>
                <p className="text-muted lh-lg mb-3">
                  إذا كنت تبحث عن <strong>سداد قروض صبيا</strong> أو{" "}
                  <strong>مكتب سداد أبو عريش</strong> أو{" "}
                  <strong>مكتب صبيا</strong> لتسديد القروض وإنهاء التعثر البنكي،
                  فنحن نقدّم خدمة متكاملة تشمل تسديد متعثرات سمة، رفع الاسم من
                  سمة، فك إيقاف الخدمات، تحويل الراتب من بنك لآخر، واستخراج قرض
                  شخصي أو تمويل عقاري بعد تسوية الالتزامات.
                </p>
                <p className="text-muted lh-lg mb-3">
                  يبحث كثير من العملاء في السعودية عن كلمات مثل: تسديد قروض
                  صبيا، سداد إيقاف خدمات صبيا، مكتب تسديد قروض أبو عريش، سداد
                  قروض جازان، سداد قروض الراجحي، سداد قروض الأهلي، جدولة
                  المديونية، توحيد الالتزامات، ومخالصة بنكية. نقدّم هذه الحلول
                  لعملاء صبيا وأبو عريش وجازان وبيش وصامطة وأحد المسارحة وضمد
                  وفيفا وفرسان وبقية المحافظات.
                </p>
                <p className="text-muted lh-lg mb-0">
                  هدفنا مساعدتك في سداد الديون البنكية بسرعة وسرية، سواء كانت
                  قروض مدنيين أو عسكريين أو قطاع خاص، مع متابعة تحديث سمة ورفع
                  إيقاف الخدمات حتى تستعيد استقرارك المالي وتتمكن من التمويل
                  الجديد عند الحاجة.
                </p>
              </div>
            </div>
          </article>
        </div>
      </section>

      <section
        className="section section-alt"
        id="faq"
        aria-labelledby="faq-heading"
      >
        <div className="container">
          <header className="section-head text-center">
            <h2 id="faq-heading">الأسئلة الشائعة حول سداد القروض</h2>
            <p className="text-muted mb-0">
              إجابات عن سداد قروض صبيا ومكتب سداد أبو عريش وسمة وإيقاف الخدمات
            </p>
          </header>

          <div className="row justify-content-center">
            <div className="col-12 col-lg-8">
              <div className="accordion faq-accordion" id="faqAccordion">
                {faqItems.map((item, index) => (
                  <article
                    key={item.id}
                    className={`accordion-item border-0 ${
                      index < faqItems.length - 1 ? "border-bottom" : ""
                    }`}
                  >
                    <h3 className="accordion-header" id={`${item.id}-heading`}>
                      <button
                        className={`accordion-button fw-bold text-end ${
                          item.open ? "" : "collapsed"
                        }`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#${item.id}`}
                        aria-expanded={item.open ? "true" : "false"}
                        aria-controls={item.id}
                      >
                        {item.question}
                      </button>
                    </h3>
                    <div
                      id={item.id}
                      className={`accordion-collapse collapse ${
                        item.open ? "show" : ""
                      }`}
                      data-bs-parent="#faqAccordion"
                      role="region"
                      aria-labelledby={`${item.id}-heading`}
                    >
                      <div className="accordion-body text-muted small text-end">
                        <p className="mb-0">{item.answer}</p>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Home;
